"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductDetailModal = exports.ProductDetailModalProvider = exports.ProductDetailModalContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_2 = require("react");
const product_1 = require("../utils/product");
/**
 * @type InitialState
 * @typedef {Object} InitialState
 * @property {boolean} isOpen
 * @property {function} setIsOpen
 * @property {Object} selectedProduct
 * @property {function} setSelectedProduct
 * @property {boolean} isCartItem
 * @property {function} setIsCartItem
 * @property {string} modalAction
 * @property {function} setModalAction
 */
const initialState = {
    isOpen: false,
    setIsOpen: () => { },
    selectedProduct: null,
    setSelectedProduct: () => { },
    isCartItem: false,
    setIsCartItem: () => { },
    modalAction: 'add',
    setModalAction: () => { },
    products: [],
    setProducts: () => { },
    detailModalProductData: { catalogData: [], contentData: [] }
};
/**
 * Context for DetailModalProvider
 * @type {Object}
 * @property {InitialState} initialState
 */
exports.ProductDetailModalContext = (0, react_2.createContext)(initialState);
const ProductDetailModalProvider = ({ children, apiRoutes }) => {
    const [isOpen, setIsOpen] = (0, react_2.useState)(initialState.isOpen);
    const [selectedProduct, setSelectedProduct] = (0, react_2.useState)(initialState.selectedProduct);
    const [isCartItem, setIsCartItem] = (0, react_2.useState)(initialState.isCartItem);
    const [modalAction, setModalAction] = (0, react_2.useState)(initialState.modalAction);
    const [products, setProducts] = (0, react_2.useState)(initialState.products);
    const [detailModalProductData, setDetailModalProductData] = (0, react_2.useState)(initialState.detailModalProductData);
    (0, react_2.useEffect)(() => {
        const fetchData = async () => {
            if (products.length !== 0) {
                const { catalogData, contentData } = await (0, product_1.fetchCatalogAndContentData)(products, apiRoutes);
                setDetailModalProductData({
                    catalogData: catalogData,
                    contentData: contentData
                });
            }
        };
        fetchData();
    }, [products]);
    return ((0, jsx_runtime_1.jsx)(exports.ProductDetailModalContext.Provider, { value: {
            isOpen,
            setIsOpen,
            selectedProduct,
            setSelectedProduct,
            isCartItem,
            setIsCartItem,
            modalAction,
            setModalAction,
            products,
            setProducts,
            detailModalProductData,
            imgixUrl: apiRoutes.imgix
        }, children: children }));
};
exports.ProductDetailModalProvider = ProductDetailModalProvider;
exports.ProductDetailModalContext.displayName = 'ProductDetailModalContext';
/**
 * Hook for DetailModalProvider
 * @returns {InitialState}
 */
const useProductDetailModal = () => {
    const detailModal = (0, react_1.useContext)(exports.ProductDetailModalContext);
    if (typeof detailModal === 'undefined') {
        throw new Error('useDetailModal must be used within DetailModalProvider');
    }
    return detailModal;
};
exports.useProductDetailModal = useProductDetailModal;
//# sourceMappingURL=modal-context.js.map